import { render, staticRenderFns } from "./updatehistory.vue?vue&type=template&id=456da5eb&"
import script from "./updatehistory.vue?vue&type=script&lang=js&"
export * from "./updatehistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports